import React from "react";
import { Box } from "@mui/system";
import RadioButtonUncheckedRoundedIcon from "@mui/icons-material/RadioButtonUncheckedRounded";
import RadioButtonCheckedRoundedIcon from "@mui/icons-material/RadioButtonCheckedRounded";

const LoginHeader = ({ type }) => {
  return (
    <Box
      sx={{
        display: "flex",
        position: "fixed",
        top: 0,
        right: 0,
        left: 0,
        height: "100px",
        backgroundColor: "white.main",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          width: "100%",
          mx: "22px",
          borderBottom: "2px solid",
          borderColor: "black.main",
          position: "relative",
        }}
      >
        <RadioButtonCheckedRoundedIcon
          sx={{
            position: "absolute",
            left: -9,
            top: -11,
            color: "black.main",
            backgroundColor: "white.main",
          }}
        />

        {type === "editName" ? (
          <RadioButtonUncheckedRoundedIcon
            sx={{
              position: "absolute",
              left: "47%",
              top: -11,
              color: "mute.main",
              backgroundColor: "white.main",
            }}
          />
        ) : (
          <RadioButtonCheckedRoundedIcon
            sx={{
              position: "absolute",
              left: "47%",
              top: -11,
              color: "black.main",
              backgroundColor: "white.main",
            }}
          />
        )}

        {type === "editCategory" ? (
          <RadioButtonCheckedRoundedIcon
            sx={{
              position: "absolute",
              right: -11,
              top: -11,
              color: "black.main",
              backgroundColor: "white.main",
            }}
          />
        ) : (
          <RadioButtonUncheckedRoundedIcon
            sx={{
              position: "absolute",
              right: -11,
              top: -11,
              color: "mute.main",
              backgroundColor: "white.main",
            }}
          />
        )}
      </Box>
    </Box>
  );
};

export default LoginHeader;
